import { render, staticRenderFns } from "./GridItemAdd.vue?vue&type=template&id=2d1b5136&scoped=true"
import script from "./GridItemAdd.vue?vue&type=script&lang=js"
export * from "./GridItemAdd.vue?vue&type=script&lang=js"
import style0 from "./GridItemAdd.vue?vue&type=style&index=0&id=2d1b5136&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d1b5136",
  null
  
)

export default component.exports